interface IconCloseOptions {
    cssClasses? : string
}

export function IconClose(props : IconCloseOptions) {
    return (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" className={props?.cssClasses}>
            <path d="M0.958984 0.777832L9.41488 9.23411" stroke="black" stroke-linecap="round"/>
            <path d="M9.41602 0.771973L0.960118 9.22825" stroke="black" stroke-linecap="round"/>
        </svg>
    );
}
